export {default as StepAccountsReminder} from './1-StepAccountsReminder';
export {default as StepRetirementAge} from './2-StepRetirementAge';
export {default as StepReversible} from './3-StepReversible';
export {default as StepDistribution} from './4-StepDistribution';
export {default as StepAnnuityType} from './5-StepAnnuityType';
export {default as StepMrmResult} from './6-StepMrmResult';
